// The `--odin-*` variables on the html element (spec §4). Light on :root,
// dark under html[data-theme="dark"] — the attribute ThemeProvider (and the
// pre-paint script in index.html) sets. Generated from the palettes, never
// hand-written. Mounted once in App.jsx next to GlobalStyles.
import { createGlobalStyle } from 'styled-components';
import { DARK, LIGHT, toCssBlock } from './claudeTokens';

export const ClaudeVars = createGlobalStyle`
  :root {
${toCssBlock(LIGHT)}
  }

  html[data-theme="dark"] {
${toCssBlock(DARK)}
  }
`;

export default ClaudeVars;
